import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {getCompany} from "../index";
import {BASE_URL} from "../Landing/Components/Api/Api";


export const getCity = createAsyncThunk('get-city', async (provinceId) => {
    const bodyFormData = new FormData()
    bodyFormData.append('provinceId', provinceId)
    // console.log(bodyFormData.get('mob'), 'body of login')
    try{

        const response = await axios.post(BASE_URL, bodyFormData, {
            headers: {
                "Content-type": "multipart/form-data",
                'Accept': 'application/json',
                'cmd': 'city'
            },
        });
        if (response.status === 200) {
            const data = await response.data

            return data?.dt
        } else {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    }catch (error){
        throw error;
    }
});



const initialState = {
    city: [],
    loading: false,
    error: null,
};

export const CitySlice = createSlice({
    name: "city",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getCity.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCity.fulfilled, (state, action) => {
                state.loading = false;
                state.city = action.payload;
            })
            .addCase(getCity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});


export default CitySlice.reducer;